import { render, staticRenderFns } from "./status-to-collect-in-sp.component.vue?vue&type=template&id=55af686a"
import script from "./status-to-collect-in-sp.component.ts?vue&type=script&lang=ts&external"
export * from "./status-to-collect-in-sp.component.ts?vue&type=script&lang=ts&external"
import style0 from "./status-to-collect-in-sp.component.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports